import React from "react";
import commonStyles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import PortfolioCompareTableDelta from "./../PortfolioCompareTableDelta";
import { useComparisonLabels } from "../../ComparisonLabelsContext";
type SectionChildrenProps = { reportData: any; reportData2?: any };
const StressDeiPortafogliScenariNegativiCompare: React.FC<
  SectionChildrenProps
> = ({ reportData, reportData2 }) => {
  const labels = useComparisonLabels();
  if (!reportData) {
    return <></>;
  }

  return (
    <>
      {reportData2 && (
        <div className={commonStyles.sectionContainerBacktest}>
          {/* **********CONTENT ********** */}
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            subSection={true}
            titleDelta={`Delta stress test del portafoglio su ipotesi storiche - scenari negativi (${labels.portfolio2} vs ${labels.portfolio1})`}
            dataItem={{
              data: reportData.analisi_backtest
                .stress_del_portafoglio_eventi_scenari_negativi,
              configData: {
                label:
                  "Stress test dei portafogli su ipotesi storiche - scenari negativi",
                label_table_left: "Ipotesi storiche - scenari negativi",
                label_table_right: "Peso (%)",
                palette: "palette2",
                type: "whatever",
              },
            }}
            dataItem2={{
              data: reportData2.analisi_backtest
                .stress_del_portafoglio_eventi_scenari_negativi,
              configData: {
                label: "",
                label_table_left: "",
                label_table_right: "",
                palette: "palette2",
                type: "whatever",
              },
            }}
            hideTotal={true}
          />
          <div style={{ marginTop: 16 }}></div>
          <PortfolioCompareTableDelta
            titleDelta={`Delta stress test del portafoglio su ipotesi storiche - scenari positivi (${labels.portfolio2} vs ${labels.portfolio1})`}
            subSection={true}
            dataItem={{
              data: reportData.analisi_backtest
                .stress_del_portafoglio_eventi_scenari_positivi,
              configData: {
                label:
                  "Stress test dei portafogli su ipotesi storiche - scenari positivi",
                label_table_left: "Ipotesi storiche - scenari positivi",
                label_table_right: "Peso (%)",
                palette: "palette2",
                type: "whatever",
              },
            }}
            dataItem2={{
              data: reportData2.analisi_backtest
                .stress_del_portafoglio_eventi_scenari_positivi,
              configData: {
                label: "",
                label_table_left: "",
                label_table_right: "",
                palette: "palette2",
                type: "whatever",
              },
            }}
            hideTotal={true}
          />
        </div>
      )}
    </>
  );
};
export default React.memo(
  StressDeiPortafogliScenariNegativiCompare,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    // Custom comparison function
    return prevProps.reportData === nextProps.reportData;
  },
);
